import { Component, signal } from '@angular/core';
import { InputComponent } from '@flowkit/input';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ErrorComponent } from '@flowkit/error';

@Component({
  imports: [InputComponent, ReactiveFormsModule, FormsModule, ErrorComponent],
  selector: 'app-ui-inputs',
  template: `
    <div>
      <h1 class="heading-title">Inputs</h1>
      <div class="flex flex-col gap-10">
        <flk-input
          [(ngModel)]="value"
          [placeholder]="'Your name'"
          [label]="'Name'"
          class="w-96" />
        <flk-input
          [formControl]="control1"
          [placeholder]="'Your name'"
          [label]="'Name'"
          class="w-96" />
        <flk-input
          [formControl]="control2"
          [placeholder]="'Your name'"
          [label]="'Name'"
          class="w-96" />
        <flk-input
          [formControl]="control3"
          [placeholder]="'Your name'"
          [label]="'Name'"
          class="w-96">
          <flk-error>Name is required</flk-error>
        </flk-input>
        <flk-input
          [formControl]="control4"
          [placeholder]="'Your name'"
          class="w-96" />
      </div>
    </div>
  `,
})
export class UIInputsComponent {
  control1 = new FormControl('Marcelo');
  control2 = new FormControl({ value: 'Marcelo', disabled: true });
  control3 = new FormControl('', [Validators.required]);
  control4 = new FormControl('');

  value = 'Marcelo';
  disabled = signal(false);
}
